export default "__VITE_ASSET__Mw4a6Vrm__"